import { ProgramsForm } from "../../components/Forms/index";

const NewPrograms = () => {
  return <ProgramsForm />;
};

export default NewPrograms;
